// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldsetFieldsWrapper_wrapper__Cjdj+"};